<template>
    <div class="status">
        <div class="status_column">
            <div class="title" v-if="title">{{ title }}</div>
            <img class="small" v-if="size == 'small'" draggable="false" src="../../assets/empty_noData.png" alt />
            <img class="big" v-else-if="size == 'big'" draggable="false" src="../../assets/big_empty_noData.png" alt />
            <div v-html="message"></div>
            <a draggable="false" href="javascript:;" v-if="btnTxt" @click="btnClick">{{ btnTxt }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'list-status',
    props: {
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        btnTxt: {
            type: String,
            default: ''
        },
        btnClick: {
            type: Function,
            default: function() {}
        },
        size: {
            type: String,
            default: 'big'
        }
    },
    data() {
        return {}
    },
    components: {},
    created() {},
    mounted() {},
    methods: {}
}
</script>

<style scoped lang="less">
.status {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    img.small {
        width: 81px;
        height: 43px;
        object-fit: contain;
    }

    img.big {
        width: 151px;
        height: 81px;
        object-fit: contain;
    }

    div {
        text-align: center;
        font-size: 14px;
        color: #999;
    }

    a {
        margin-top: 20px;
        display: inline-block;
        width: 120px;
        line-height: 40px;
        border-radius: 40px;
        border: 1px solid rgba(50, 227, 166, 1);
        color: rgba(50, 227, 166, 1);
        font-size: 18px;
    }

    .title {
        text-align: left;
        color: #999;
        font-size: 14px;
    }
}
</style>
